import messagesEn from './locale/en-US.json'
//import messagesEs from './locale / es - US.json'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'
import { IntlProvider } from 'react-intl'
import { ClarityLoader } from './components/Clarity/ClarityLoader'
import { GoogleAnalyticsLoader } from './components/GoogleAnalytics/GoogleAnalyticsLoader'
import { Locale } from './constants'
import { router } from './router'
import type { JotaiStore } from './state'
import { useCreateJotaiStore } from './state'
import { useReactQuery } from './utils/dataFetching/QueryClient'

const messages: Record<Locale, typeof messagesEn> = {
  [Locale.EN]: messagesEn,
  //[Locale.ES]: messagesEs, // will add spanish localization in the future, need human translation for the messages first
}

interface AppContentProps {
  jotaiStore: JotaiStore
  queryClient: QueryClient
}

function AppContent({ jotaiStore, queryClient }: AppContentProps) {
  // will add spanish localization in the future, need human translation for the messages first
  //const browserLocale = navigator.languages?.[0] ?? navigator.language
  // const locale: Locale = (Object.values(Locale) as string[]).includes(
  //   browserLocale,
  // )
  //   ? (browserLocale as Locale)
  //   : Locale.EN

  return (
    <IntlProvider locale={Locale.EN} messages={messages[Locale.EN]}>
      <RouterProvider router={router} context={{ jotaiStore, queryClient }} />
    </IntlProvider>
  )
}

function App() {
  const jotaiStore = useCreateJotaiStore()
  const queryClient = useReactQuery()

  return (
    <JotaiProvider store={jotaiStore}>
      <QueryClientProvider client={queryClient}>
        <ClarityLoader />
        <GoogleAnalyticsLoader />
        <AppContent jotaiStore={jotaiStore} queryClient={queryClient} />
      </QueryClientProvider>
    </JotaiProvider>
  )
}

export default App
